import {Vehicle} from '../../../gql/customer/graphql.ts';
import {SimpleSlider} from '../../../components/slider.tsx';
import {VehicleCard} from '../../../components/vehicle/vehicle_card.tsx';
import styles from './vehicles_slider.module.scss';
import {VehiclePlaceholder} from '../../../components/vehicle/vehicle_placeholder.tsx';

interface OwnProps {
    vehicles?: (Vehicle | undefined | null)[] | null;
}

export function VehiclesSlider({vehicles}: OwnProps) {
    return (
        <div className={styles.vehicle_slider}>
            <SimpleSlider className={'dashboard-vehicles-slider'} infinite={false}>
                {vehicles && vehicles.length !== 0 ? (
                    vehicles?.map(
                        (vehicle, key) => vehicle && <VehicleCard key={`${key}-${vehicle?.id}`} vehicle={vehicle} />,
                    )
                ) : (
                    <VehiclePlaceholder style={{opacity: 0.7}} />
                )}
            </SimpleSlider>
        </div>
    );
}
